var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BorrarModalComponent',{attrs:{"name":'borrar-' + _vm.ad_id,"title":"¿Seguro que quieres borrar este aviso?","confirmButton":"¿BORRAR AVISO?"},on:{"close":() => _vm.close(false),"confirm":() => _vm.borrarAviso()}})
}
var staticRenderFns = []

export { render, staticRenderFns }